import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContractsEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 260.025,
	height: 195.817,
	viewBox: "0 0 260.025 195.817",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "contractEmptyStateClipPath",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13405",
				"data-name": "Rectangle 13405",
				width: 215.137,
				height: 166.36,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "contractEmptyStateClipPath-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13404",
				"data-name": "Rectangle 13404",
				width: 202.715,
				height: 166.36,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "contractEmptyStateClipPath-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13403",
				"data-name": "Rectangle 13403",
				width: 6.632,
				height: 138.595,
				fill: "#edf4fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "contractEmptyStateClipPath-4",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13424",
				"data-name": "Rectangle 13424",
				width: 167.526,
				height: 127.069,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "contractEmptyStateClipPath-6",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13418",
				"data-name": "Rectangle 13418",
				width: 39.709,
				height: 39.708,
				fill: "none"
			})
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_7654",
		"data-name": "Group 7654",
		transform: "translate(0 0)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_7646",
			"data-name": "Group 7646",
			transform: "translate(0 0)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_13001",
				"data-name": "Path 13001",
				d: "M236.987,195.821c9.044-14.83,21.752-43.208,22.828-61.539,1.591-27.1-5.945-27.958-18.531-42.023-5.489-6.134,9.925-25.541-13.475-41.573-14.518-9.946-34.093,10.055-46.138-14.751C166.744,5.193,115.321-2.136,87.3.5,44.48,4.523,15.823,29.175,8.574,45.514c-26.355,59.4,17.973,63.131,1.9,92.069-12.88,23.184,6.728,48.453,13.215,56.395Z",
				transform: "translate(0 -0.004)",
				fill: "#edf4fa"
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_7645",
				"data-name": "Group 7645",
				transform: "translate(31.077 18.957)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_7644",
					"data-name": "Group 7644",
					clipPath: "url(#contractEmptyStateClipPath)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_7643",
						"data-name": "Group 7643",
						transform: "translate(7.644 0)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_7642",
							"data-name": "Group 7642",
							clipPath: "url(#contractEmptyStateClipPath-2)",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12985",
									"data-name": "Path 12985",
									d: "M1216.081,153.59l-103.957-3.9a3.555,3.555,0,0,1-3.419-3.686l5.348-142.587A3.555,3.555,0,0,1,1117.739,0L1221.7,3.9a3.555,3.555,0,0,1,3.419,3.686l-5.348,142.587a3.555,3.555,0,0,1-3.686,3.419",
									transform: "translate(-1054.148 0.004)",
									fill: "#d3e6f5"
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_7641",
									"data-name": "Group 7641",
									transform: "translate(155.301 14.999)",
									opacity: .22,
									style: {
										mixBlendMode: "multiply",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_7640",
										"data-name": "Group 7640",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_7639",
											"data-name": "Group 7639",
											clipPath: "url(#contractEmptyStateClipPath-3)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_12986",
												"data-name": "Path 12986",
												d: "M2904.515,267.359l6.632,138.595h-6.632Z",
												transform: "translate(-2904.514 -267.359)",
												fill: "#edf4fa"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12988",
									"data-name": "Path 12988",
									d: "M1034.577,350.232a3.555,3.555,0,0,1-3.555,3.555H926.992a3.555,3.555,0,0,1-3.555-3.555V207.545a3.555,3.555,0,0,1,3.555-3.555h104.03a3.555,3.555,0,0,1,3.555,3.555",
									transform: "translate(-879.276 -192.546)",
									fill: "#fff"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12989",
									"data-name": "Path 12989",
									d: "M1547.05,518.516H1507a2.973,2.973,0,0,1,0-5.947h40.05a2.973,2.973,0,0,1,0,5.947",
									transform: "translate(-1427.293 -483.813)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12990",
									"data-name": "Path 12990",
									d: "M1254.824,810.017h-76.982a2.973,2.973,0,0,1,0-5.947h76.982a2.973,2.973,0,1,1,0,5.947",
									transform: "translate(-1116.601 -758.961)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12991",
									"data-name": "Path 12991",
									d: "M1254.824,1101.518h-76.982a2.973,2.973,0,0,1,0-5.947h76.982a2.973,2.973,0,0,1,0,5.947",
									transform: "translate(-1116.601 -1034.108)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12992",
									"data-name": "Path 12992",
									d: "M1254.824,1393.018h-76.982a2.973,2.973,0,0,1,0-5.947h76.982a2.973,2.973,0,0,1,0,5.947",
									transform: "translate(-1116.601 -1309.255)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12993",
									"data-name": "Path 12993",
									d: "M1477.64,1841.311h-47.326a2.973,2.973,0,1,1,0-5.947h47.326a2.973,2.973,0,0,1,0,5.947",
									transform: "translate(-1354.91 -1732.398)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12994",
									"data-name": "Path 12994",
									d: "M1181.538,1838.337a2.973,2.973,0,1,1-2.973-2.973,2.973,2.973,0,0,1,2.973,2.973",
									transform: "translate(-1117.284 -1732.398)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12995",
									"data-name": "Path 12995",
									d: "M1477.64,2046.676h-47.326a2.973,2.973,0,1,1,0-5.947h47.326a2.973,2.973,0,0,1,0,5.947",
									transform: "translate(-1354.91 -1926.242)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12996",
									"data-name": "Path 12996",
									d: "M1181.538,2043.7a2.973,2.973,0,1,1-2.973-2.973,2.973,2.973,0,0,1,2.973,2.973",
									transform: "translate(-1117.284 -1926.242)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12997",
									"data-name": "Path 12997",
									d: "M1477.64,2252.041h-47.326a2.973,2.973,0,1,1,0-5.947h47.326a2.973,2.973,0,1,1,0,5.947",
									transform: "translate(-1354.91 -2120.086)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12998",
									"data-name": "Path 12998",
									d: "M1181.538,2249.067a2.973,2.973,0,1,1-2.973-2.973,2.973,2.973,0,0,1,2.973,2.973",
									transform: "translate(-1117.284 -2120.086)",
									fill: "#042479"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_12999",
									"data-name": "Path 12999",
									d: "M1477.64,2457.406h-47.326a2.973,2.973,0,1,1,0-5.947h47.326a2.973,2.973,0,1,1,0,5.947",
									transform: "translate(-1354.91 -2313.931)",
									fill: "#e3edfc"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_13000",
									"data-name": "Path 13000",
									d: "M1181.538,2454.433a2.973,2.973,0,1,1-2.973-2.973,2.973,2.973,0,0,1,2.973,2.973",
									transform: "translate(-1117.284 -2313.931)",
									fill: "#042479"
								})
							]
						})
					})
				})
			})]
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_7653",
			"data-name": "Group 7653",
			transform: "translate(42.014 67.248)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_7652",
				"data-name": "Group 7652",
				clipPath: "url(#contractEmptyStateClipPath-4)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_7651",
					"data-name": "Group 7651",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_7650",
						"data-name": "Group 7650",
						clipPath: "url(#contractEmptyStateClipPath-4)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13003",
								"data-name": "Path 13003",
								d: "M309.495,0",
								transform: "translate(-154.748)",
								fill: "#032478"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13006",
								"data-name": "Path 13006",
								d: "M76.8,82.229s.381-.857.627-1.262,1.3-1.594,1.48-1.325.9,2.08.515,2.587.025,1.389-1.87,1.923Z",
								transform: "translate(-38.401 -39.801)",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13007",
								"data-name": "Path 13007",
								d: "M34.673,74.039s9.7,8.1,13.486,7.35a74.54,74.54,0,0,0,7.5-2.143l.908,2.323s-4.072,5.523-8.317,5.56a24.188,24.188,0,0,1-11.538-2.873Z",
								transform: "translate(-17.337 -37.02)",
								fill: "#667ee8"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13008",
								"data-name": "Path 13008",
								d: "M.639,243.441S.92,247.985,1.8,248.05c.116.008,4.458.008,4.458.008l5.542-.032a1.8,1.8,0,0,0-1.656-1.617c-1.62-.283-4.331-1.421-5.313-3.562-1.033-2.253-4.192.594-4.192.594",
								transform: "translate(-0.32 -120.99)",
								fill: "#074a92"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13009",
								"data-name": "Path 13009",
								d: "M0,189.438A11.56,11.56,0,0,0,3,190a11.019,11.019,0,0,0,2.8-.4,76.74,76.74,0,0,1,2.063-9.827c.915-3.543,2.222-8.1,4.082-13.758,5.141-15.643,6.7-24.794,6.847-25.66.007-.046.01-.069.01-.069l-.016-.007L2.981,133.341s1.954,21.56-.539,29.834a34.918,34.918,0,0,0-.9,3.964C-.037,176.129,0,189.438,0,189.438",
								transform: "translate(0 -66.671)",
								fill: "#032478"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13010",
								"data-name": "Path 13010",
								d: "M10.291,179.775c.915-3.543,2.222-8.1,4.082-13.758,5.141-15.642,6.7-24.793,6.847-25.66,0-.026,0-.05-.006-.076L5.408,133.341s1.953,21.56-.539,29.835c-.349,1.156,5.422,16.6,5.422,16.6",
								transform: "translate(-2.427 -66.671)",
								fill: "#061a3d"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13011",
								"data-name": "Path 13011",
								d: "M25.329,243.441s.281,4.544,1.161,4.609c.117.008,4.459.008,4.459.008l5.542-.032a1.8,1.8,0,0,0-1.657-1.617c-1.62-.283-4.332-1.421-5.313-3.562-1.032-2.253-4.192.594-4.192.594",
								transform: "translate(-12.665 -120.99)",
								fill: "#074a92"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13012",
								"data-name": "Path 13012",
								d: "M26.446,134.357a224.966,224.966,0,0,1-2.212,31.124c-2.417,17.153-1.6,24.435-1.6,24.435a16.468,16.468,0,0,1-2.331.592,10.586,10.586,0,0,1-3.458-.4s-3.46-17.16-2.468-25.746S9.642,134.9,9.642,134.9Z",
								transform: "translate(-4.821 -67.179)",
								fill: "#032478"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13013",
								"data-name": "Path 13013",
								d: "M20.836,62.064l3.085,2.023,2.81-.794a6.717,6.717,0,0,0,.657-3.369,21.014,21.014,0,0,0-.11-2.244l-4.163-1.837-1.553-.684c0,.024.121,1.275.138,1.458a10.622,10.622,0,0,1-.864,5.448",
								transform: "translate(-10.418 -27.579)",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13014",
								"data-name": "Path 13014",
								d: "M23.914,104.376c-3.84,3.708-18.373,3.084-19.269-1s.977-34.774,7.536-36.7c1.361-.4,8.638,1.952,8.638,1.952a46.131,46.131,0,0,1,1.891,6.791c.145.74.569,8.583.887,15.92.148,3.431.274,6.753.338,9.185a26.48,26.48,0,0,1-.022,3.856",
								transform: "translate(-2.218 -33.313)",
								fill: "#899bfa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13015",
								"data-name": "Path 13015",
								d: "M23.069,57.358c.844,1.428,3.807,2.677,5.377,3.25a21.018,21.018,0,0,0-.11-2.244l-4.162-1.837c-.92-.012-1.48.194-1.1.831",
								transform: "translate(-11.475 -28.263)",
								fill: "#ffa05e"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13016",
								"data-name": "Path 13016",
								d: "M27.508,48.655s-6.706,2.092-7.945-2.1-2.938-6.753,1.292-8.267,5.538-.159,6.292,1.142,2.075,8.576.362,9.229",
								transform: "translate(-9.077 -18.808)",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13017",
								"data-name": "Path 13017",
								d: "M23.965,36.731s-.428,4.883-1.437,4.671-2.122-.665-1.974.807-.982,4-2.438,3.99c-3.123-.013-6.517-8.027-5.662-9.547,2.468-4.385,15.078-5.27,11.512.079",
								transform: "translate(-6.159 -16.517)",
								fill: "#0b3563"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13018",
								"data-name": "Path 13018",
								d: "M26.781,64.869c-.087-.036-4.992-2.237-5.566-2.048s-1.289,1.942-1.289,1.942l8.639,1.953a4.29,4.29,0,0,0-1.783-1.847",
								transform: "translate(-9.963 -31.405)",
								fill: "#667ee8"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13019",
								"data-name": "Path 13019",
								d: "M64.652,111.835l-27.5,25.894c-.539.507-1.219.669-1.511.359l-.929-.986c-.292-.309-.09-.978.45-1.486l27.5-25.894c.539-.507,1.219-.67,1.511-.36l.928.986c.292.31.09.979-.45,1.486",
								transform: "translate(-17.288 -54.603)",
								fill: "#0b4d87"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13020",
								"data-name": "Path 13020",
								d: "M49.218,141.414,37.149,152.776c-.54.508-1.219.67-1.511.359l-.928-.986c-.292-.31-.09-.978.45-1.486L47.228,139.3Z",
								transform: "translate(-17.288 -69.651)",
								fill: "#6b98f6"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13021",
								"data-name": "Path 13021",
								d: "M81.149,67.065A21.557,21.557,0,1,0,116.878,45.4c-.11-.11-.224-.219-.338-.326A21.558,21.558,0,0,0,81.149,67.065m6.161-19.9a19.856,19.856,0,1,1,.855,28.066,19.831,19.831,0,0,1-.855-28.066",
								transform: "translate(-40.107 -19.61)",
								fill: "#0b4d87"
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_7649",
								"data-name": "Group 7649",
								transform: "translate(41.808 21.312)",
								opacity: .5,
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_7648",
									"data-name": "Group 7648",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_7647",
										"data-name": "Group 7647",
										clipPath: "url(#contractEmptyStateClipPath-6)",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_13022",
											"data-name": "Path 13022",
											d: "M117.932,76.082a19.856,19.856,0,1,1-.856-28.065,19.778,19.778,0,0,1,.856,28.065",
											transform: "translate(-83.617 -42.624)",
											fill: "#accefc"
										})
									})
								})
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13023",
								"data-name": "Path 13023",
								d: "M29.515,109.2C14.361,98.406,15.621,84,15.621,84c5.539,3.124,11.035,10.031,13.556,16.022.148,3.431.273,6.753.338,9.185",
								transform: "translate(-7.798 -41.999)",
								fill: "#667ee8"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13024",
								"data-name": "Path 13024",
								d: "M71.534,123.382a4.136,4.136,0,0,0,1.936-1.2s.456.031-.075,1c-.044.081-.143.29-.217.438a.094.094,0,0,0,.079.135,10.084,10.084,0,0,1,2.424.051c.164.034.212.426.205.594a1.516,1.516,0,0,1-.319,1.035,5.3,5.3,0,0,1-1.915,1,5.8,5.8,0,0,1-2.963-.372l-.97-.449.3-1.8.243.051c.387.081.867-.392,1.27-.491",
								transform: "translate(-34.86 -61.094)",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13025",
								"data-name": "Path 13025",
								d: "M20.034,70.624S6.417,73.216,24.04,92.934c2.819,3.154,18.045,7.26,18.045,7.26s1.545-1.314.766-2.379c0,0-10.485-7.613-12.791-8.824-1.038-.545-4.028-12.151-5.719-14.947a7.625,7.625,0,0,0-4.307-3.422",
								transform: "translate(-7.507 -35.312)",
								fill: "#899bfa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_13026",
								"data-name": "Path 13026",
								d: "M77.539,82.014a6.934,6.934,0,0,0,.533-1.3,7.188,7.188,0,0,1,.878-1.989c.092-.092.4.027.434.424a2.327,2.327,0,0,1-.219.861,9.684,9.684,0,0,0-.288,1.712c-.211.686-1.338.292-1.338.292",
								transform: "translate(-38.77 -39.348)",
								fill: "#ffae73"
							})
						]
					})
				})
			})
		})]
	})]
});
export default SvgContractsEmptyState;
